import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import '../styles/AdminBreadcrumb.css';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const AdminBreadcrumb: React.FC = () => {
  const location = useLocation();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const path = location.pathname;

    // Notícias - Listar
    if (path === '/admin' || path === '/admin/') {
      return [
        { label: 'Notícias', path: '/admin' },
        { label: 'Listar' },
      ];
    }

    // Notícias - Criar
    if (path === '/admin/noticias/criar') {
      return [
        { label: 'Notícias', path: '/admin' },
        { label: 'Criar' },
      ];
    }

    // Notícias - Editar
    if (path.startsWith('/admin/noticias/editar/')) {
      return [
        { label: 'Notícias', path: '/admin' },
        { label: 'Editar' },
      ];
    }

    // Categorias - Listar
    if (path === '/admin/categorias') {
      return [
        { label: 'Categorias', path: '/admin/categorias' },
        { label: 'Listar' },
      ];
    }

    // Categorias - Criar
    if (path === '/admin/categorias/criar') {
      return [
        { label: 'Categorias', path: '/admin/categorias' },
        { label: 'Criar' },
      ];
    }

    // Categorias - Editar
    if (path.startsWith('/admin/categorias/editar/')) {
      return [
        { label: 'Categorias', path: '/admin/categorias' },
        { label: 'Editar' },
      ];
    }

    // Projetos - Listar
    if (path === '/admin/projetos') {
      return [
        { label: 'Projetos', path: '/admin/projetos' },
        { label: 'Listar' },
      ];
    }

    // Projetos - Criar
    if (path === '/admin/projetos/criar') {
      return [
        { label: 'Projetos', path: '/admin/projetos' },
        { label: 'Criar' },
      ];
    }

    // Projetos - Editar
    if (path.startsWith('/admin/projetos/editar/')) {
      return [
        { label: 'Projetos', path: '/admin/projetos' },
        { label: 'Editar' },
      ];
    }

    // Cotações - Listar
    if (path === '/admin/quotations') {
      return [
        { label: 'Cotações', path: '/admin/quotations' },
        { label: 'Listar' },
      ];
    }

    // Cotações - Criar
    if (path === '/admin/quotations/new') {
      return [
        { label: 'Cotações', path: '/admin/quotations' },
        { label: 'Criar' },
      ];
    }

    return [{ label: 'Dashboard' }];
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <Breadcrumb className="admin-breadcrumb">
      <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
        <i className="bi bi-house-door me-1"></i>
        Início
      </Breadcrumb.Item>
      {breadcrumbs.map((item, index) => (
        <Breadcrumb.Item
          key={index}
          linkAs={item.path ? Link : 'span'}
          linkProps={item.path ? { to: item.path } : undefined}
          active={!item.path}
        >
          {item.label}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default AdminBreadcrumb;
